// import * as api_urls from './../config/api_urls';
import * as UserActions from './../actions/user_actions';


export var session_manager =(dispatch, endpoint, payload, response, error, requestedEndpoint) => {
 
          sessionExpired(dispatch, response);
    };

/*  ------------------Deals API Failed Handler---------------------------  */
function sessionExpired(dispatch, response) {
      dispatch(UserActions.session_expired(response));
}



/** WEBPACK FOOTER **
 ** ./src/base/sesson_expired.js
 **/